(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["foam-hero"] && !Shopify.designMode) return;
  try {
    
  // Rotação automática dos banners. Pausa fora da viewport; clique no
  // dot troca na hora e reinicia o relógio.
  document.querySelectorAll('[data-foam-hero]').forEach((hero) => {
    const slides = hero.querySelectorAll('[data-foam-slide]');
    if (slides.length < 2) return;
    const dots = hero.querySelectorAll('[data-foam-dot]');
    const delay = (parseInt(hero.dataset.autoplay, 10) || 5) * 1000;
    let index = 0;
    let timer = null;
    const show = (next) => {
      index = next;
      slides.forEach((slide, n) => slide.classList.toggle('is-active', n === index));
      dots.forEach((dot, n) => {
        if (n === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };
    const start = () => {
      if (!timer) timer = setInterval(() => show((index + 1) % slides.length), delay);
    };
    const stop = () => {
      clearInterval(timer);
      timer = null;
    };
    dots.forEach((dot, n) => {
      dot.addEventListener('click', () => {
        show(n);
        stop();
        start();
      });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? start() : stop()));
      }).observe(hero);
    } else {
      start();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foam-mood-cards"] && !Shopify.designMode) return;
  try {
    
  // Mobile: carrossel passa sozinho de lado; pausa quando a pessoa
  // toca/rola e volta sozinho depois. Fora da viewport não roda.
  document.querySelectorAll('[data-foam-moods]').forEach((grid) => {
    const mq = window.matchMedia('(max-width: 749px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let timer = null;
    let resumeTimer = null;
    let visible = false;

    const step = () => {
      const card = grid.firstElementChild;
      if (!card) return;
      const gap = 14;
      const max = grid.scrollWidth - grid.clientWidth;
      if (grid.scrollLeft >= max - 8) {
        grid.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        grid.scrollBy({ left: card.offsetWidth + gap, behavior: 'smooth' });
      }
    };
    const stop = () => {
      clearInterval(timer);
      timer = null;
    };
    const sync = () => {
      if (mq.matches && visible && !reduced.matches) {
        if (!timer) timer = setInterval(step, 3000);
      } else {
        stop();
      }
    };
    ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => {
      grid.addEventListener(ev, () => {
        stop();
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(sync, 6000);
      }, { passive: true });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          visible = entry.isIntersecting;
          sync();
        });
      }).observe(grid);
    } else {
      visible = true;
      sync();
    }
    mq.addEventListener('change', sync);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foam-plane-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-foam-bubbles]').forEach((strip) => {
    if (!('IntersectionObserver' in window)) {
      strip.classList.add('is-on');
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          strip.classList.add('is-on');
          observer.disconnect();
        }
      });
    });
    observer.observe(strip);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foam-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  // Toca só o que está na tela; PAUSA o que sai (senão 3+ vídeos
  // decodificando juntos travam o scroll).
  // R4 p6: corte via player — loop dentro de [data-start, data-end].
  const items = document.querySelectorAll('[data-foam-ugc-item] video');
  if (items.length > 0) {
    items.forEach((video) => {
      const wrap = video.closest('[data-foam-ugc-item]');
      const clipStart = parseFloat(wrap.dataset.start) || 0;
      const clipEnd = parseFloat(wrap.dataset.end) || 0;
      if (clipStart <= 0 && clipEnd <= 0) return;
      video.addEventListener('timeupdate', () => {
        if (clipEnd > clipStart && video.currentTime >= clipEnd) {
          video.currentTime = clipStart;
        } else if (video.currentTime < clipStart - 0.5) {
          // loop nativo voltou pro 0: pula pro início do trecho
          video.currentTime = clipStart;
        }
      });
      video.addEventListener('loadedmetadata', () => {
        if (video.currentTime < clipStart) video.currentTime = clipStart;
      });
    });
    const start = (video) => {
      video.muted = true;
      video.preload = 'auto';
      const wrap = video.closest('[data-foam-ugc-item]');
      const clipStart = parseFloat(wrap.dataset.start) || 0;
      if (clipStart > 0 && video.currentTime < clipStart) {
        video.currentTime = clipStart;
      }
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              start(entry.target);
            } else if (!entry.target.paused) {
              entry.target.pause();
            }
          });
        },
        { rootMargin: '200px 0px' }
      );
      items.forEach((v) => observer.observe(v));
    } else {
      items.forEach(start);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
